import { string, object, bool } from 'prop-types';
import { useUser } from 'context/user';
import { useKeyboardOffset } from 'hooks/useKeyboardOffset';

import { useI18n } from 'context/i18n';
import { getIsMobile, capitalize, obtainVoucherPrices } from 'utils/helpers';

import { ChevronLeftSVG } from 'components/iconsSVG/chevronLeft';

import { getDomainValue } from 'utils/domain';
import { DOCTYPES_LIST, DOCTYPE_SCORE } from 'utils/constants/search';
import { normalizeUnbxdProducts } from 'utils/search';
import { useLocale } from 'hooks';
import { ProgressiveImg } from 'components/base';

const AutoSuggest = ({ query, data, visible, setVisible }) => {
  const { t, unbxdInitialSearch, profileData } = useI18n();
  const { locale, country, market, isoLocale, realLanguage } = useLocale();
  const { contextFilters, activatedPrevouchers, handleActivatePrevouchers } = useUser();
  const isMobile = getIsMobile('768px');
  const isTablet = getIsMobile('1200px');
  const offset = useKeyboardOffset();

  if ([undefined, null].includes(data) || visible === false) {
    return null;
  }

  const isSearchAll = ['', '*'].includes(query);
  const dataToUse = isSearchAll ? unbxdInitialSearch : data;
  const topQueries = dataToUse?.products?.filter((item) => DOCTYPES_LIST.includes(item.doctype)).map((item) => item.autosuggest);

  topQueries?.sort((a, b) => {
    const aScore = DOCTYPE_SCORE[a.doctype];
    const bScore = DOCTYPE_SCORE[b.doctype];
    let result = bScore - aScore;

    if (result < -1) result = -1;
    if (result > 1) result = 1;

    return result;
  });

  const products = dataToUse?.products?.filter((item) => item.doctype === 'POPULAR_PRODUCTS');
  const transformRegex = isSearchAll ? null : new RegExp(query, 'g');
  const transformRegexUpperCase = isSearchAll ? null : new RegExp(query.toUpperCase(), 'g');
  const transformRegexCapitalize = isSearchAll ? null : new RegExp(capitalize(query), 'g');
  const isoLang = `${realLanguage}-${market}`;
  const realMarketLang = `${market}_${realLanguage}`;
  // const formattedProducts = getProductsUnbxdFormatted(products, locale);
  const formattedProducts = normalizeUnbxdProducts(products, { country, isoLocale, realLanguage, square: true });

  const handleProductsScroll = () => {
    document.activeElement.blur();
  };

  let wrapperClass = 'unbxd-autosuggest-';

  if (isMobile) {
    wrapperClass += 'mobile';
  } else if (isTablet) {
    wrapperClass += 'tablet';
  } else {
    wrapperClass += 'desktop';
  }

  return (
    <div className={wrapperClass}>
      <div
        id="autosuggest-widget"
        className={`unbxd-as-wrapper ${isMobile ? 'unbxd-as-mobile' : 'unbxd-as-desktop'} unbxd-as-extra-right fixed left-0 top-[99px] z-50 flex !h-[80dvh] max-h-[80dvh] !flex-col !overflow-y-hidden bg-[var(--color-white)] px-[16px] shadow-md md:absolute md:top-[41px] md:!h-auto md:w-[700px] md:!flex-row-reverse md:pb-[32px] camper:lg:left-auto camper:lg:right-0 camper:lg:top-[37px] [@media(min-height:700px)]:!h-[82dvh] [@media(min-height:700px)]:max-h-[82dvh] [@media(min-height:800px)]:!h-[86dvh] [@media(min-height:800px)]:max-h-[86dvh] nnormal:[@media(min-width:1200px)]:left-auto nnormal:[@media(min-width:1200px)]:right-0 nnormal:[@media(min-width:1200px)]:top-[37px]`}
      >
        {dataToUse !== false ?
          <>
            <ul onScroll={handleProductsScroll} className={`${isMobile ? 'unbxd-as-maincontent' : 'unbxd-as-sidecontent'} xl mb-0 overflow-y-auto`}>
              <li className="unbxd-as-header flex items-center justify-between text-[12px] md:!mt-[10px] md:!pb-[15px]">
                {t('buscador', 'unbxd.best.results')}

                <a
                  href={`${window.location.origin}/${locale}/search?target=A&searchTerm=${query}`}
                  className="flex max-w-[50%] items-center justify-center self-center border-[1px] border-[var(--color-black)] bg-[#fff] p-[10px] align-middle text-[12px] font-[400] uppercase md:min-w-[155px] md:max-w-[250px] md:px-[15px] md:py-[10px] camper:md:absolute camper:md:bottom-auto camper:md:right-[0px] camper:md:top-[15px] camper:md:ml-auto camper:md:mr-[25px]"
                >
                  {t('buscador', 'unbxd.see.all')}
                  <ChevronLeftSVG className="ml-2 h-[12px] rotate-180" />
                </a>
              </li>
              {formattedProducts.map((item, index) => {
                const product = { ...item };
                const voucherPriceInfo = obtainVoucherPrices(
                  item,
                  t,
                  profileData,
                  contextFilters,
                  activatedPrevouchers,
                  handleActivatePrevouchers,
                  false,
                  false,
                  'price.message.short',
                );

                const voucherMessage = voucherPriceInfo !== null && voucherPriceInfo.message ? voucherPriceInfo.message : null;
                console.log(voucherPriceInfo);
                const applied = voucherPriceInfo?.info?.appliedLabel;
                return (
                  <li
                    key={`unbxd-product-${index}`}
                    className={`unbxd-as-popular-product unbxd-as-popular-product-grid !float-none md:p-1 md:hover:!bg-[#f6f6f6]`}
                    data-value={product.autosuggest}
                    data-src=""
                    data-index={index}
                    data-type={product.doctype}
                    data-pid={product.uniqueId}
                  >
                    <a className="unbxd-as-popular-product-info" href={product.url} aria-label={product.title}>
                      <div className="unbxd-as-popular-product-image-container unbxd-oss-img">
                        <ProgressiveImg src={product.images.md} className="unbxd-oss-image" alt="Product Image" />
                      </div>
                      <div className="unbxd-oss-name">{product.title}</div>
                      <div className="unbxd-oss-supporttext">{product.description}</div>
                      <div className="unbxd-as-popular-product-price">
                        {product.prices.previous ?
                          <>
                            <div className="unbxd-sale-price">{product.prices.currentFormated ?? null}</div>
                            <div>
                              <span className="unbxd-was-price">{product.prices.previousFormated ?? null}</span>
                              <span className="unbxd-discount ml-0.5">{product.prices.discount ? `-${product.prices.discount}%` : null}</span>
                            </div>
                          </>
                        : voucherPriceInfo?.info ?
                          applied ?
                            <>
                              <div className="unbxd-sale-price">{voucherPriceInfo?.info.currentFormated ?? null}</div>
                              <div>
                                <span className="unbxd-was-price">{voucherPriceInfo?.info?.previousFormated ?? null}</span>
                                <span className="unbxd-discount ml-0.5">{voucherPriceInfo?.info?.discountStr}</span>
                              </div>
                            </>
                          : <>
                              <div className="unbxd-sale-price">{voucherPriceInfo?.info.previousFormated ?? null}</div>
                            </>

                        : <div className="unbxd-sale-price">{product.prices.currentFormated ?? null}</div>}
                        {voucherMessage !== null && <span className="text-black text-[10px] font-medium">{voucherMessage}</span>}
                        {voucherPriceInfo?.info?.appliedLabel ?
                          <span className="text-[10px] font-medium text-success">{voucherPriceInfo?.info?.appliedLabel}</span>
                        : null}
                      </div>
                    </a>
                  </li>
                );
              })}
            </ul>
            {!isMobile && getDomainValue({ camper: true, camperlab: 'camper', nnormal: false }) && (
              <ul className="unbxd-as-maincontent">
                <li className="unbxd-as-header main-section-header">{t('buscador', 'unbxd.suggestions')}</li>
                {topQueries.map((item, index) => {
                  const transformedQuery =
                    isSearchAll ? item : (
                      item
                        .replace(transformRegex, `<b>${query}</b>`)
                        .replace(transformRegexUpperCase, `<b>${query.toUpperCase()}</b>`)
                        .replace(transformRegexCapitalize, `<b>${capitalize(query)}</b>`)
                    );

                  return (
                    <li key={`top-query-${index}`} className="unbxd-as-topqueries" data-type="TOP_SEARCH_QUERIES" data-index={index} data-value={item}>
                      <span
                        onClick={() => {
                          window.location.assign(`${window.location.origin}/${locale}/search?searchTerm=${item}&target=A`);
                        }}
                        dangerouslySetInnerHTML={{ __html: transformedQuery }}
                      />
                    </li>
                  );
                })}
              </ul>
            )}
          </>
        : <span>
            {t('buscador', 'no.results.for')} {query}
          </span>
        }
      </div>
    </div>
  );
};

AutoSuggest.propTypes = {
  data: object,
  query: string,
  visible: bool,
};

export default AutoSuggest;
